import {routerReducer as routing} from "react-router-redux"
import {combineReducers} from "redux"
import {reducer as formReducer} from 'redux-form'
import {CHANGE_HEADER_CONTENT, RESET_ALERTS} from "../actions"
import paginate from "./paginate"
import entity from "./entity"
import {HIDE_MODAL, SHOW_MODAL} from "../actions/modal"
import session from "./session"
import * as EnumsActions from '../actions/enums'
import * as UsersActions from '../actions/users'
import * as DogsActions from '../actions/dogs'
import * as PartiesActions from '../actions/parties'
import * as IntakesActions from '../actions/intakes'
import * as EventsActions from '../actions/events'
import * as TreatmentsActions from '../actions/treatments'
import * as ExitsActions from '../actions/exits'
import * as ExamsActions from '../actions/exams'
import * as WalksActions from '../actions/walks'
import * as FilesActions from '../actions/files'

const enums = (state = {}, action) => {
	const {type, key} = action;

	let newState = {...state};
	switch (type) {
		case EnumsActions.ENUM_REQUEST:
			return {
				...state,
				[key]: {
					items: {},
					isFetchingInfo: true
				}
			};
		case EnumsActions.ENUM_SUCCESS:
			return {
				...state,
				[key]: {
					items: action.response.data,
					isFetchingInfo: false
				}
			};
		case EnumsActions.ENUM_FAILURE:
			return {
				...state,
				[key]: {
					isFetchingInfo: false
				}
			};
		case EnumsActions.ENUMS_REQUEST:
			for (let i = 0; i < key.length; i++) {
				newState[key[i]] = {
					items: {},
					isFetchingInfo: true
				};
			}
			return newState;
		case EnumsActions.ENUMS_SUCCESS:
			for (let i = 0; i < key.length; i++) {
				newState[key[i]] = {
					items: action.response.data[key[i]],
					isFetchingInfo: false
				};
			}
			return newState;
		case EnumsActions.ENUMS_FAILURE:
			for (let i = 0; i < key.length; i++) {
				newState[key[i]] = {
					isFetchingInfo: false
				};
			}
			return newState;
		default:
			return state
	}
};

const defaultAlerts = {type: null, messages: []};

const alerts = (state = defaultAlerts, action) => {
	const {type, error, success, silent = false} = action;

	if (type === RESET_ALERTS) {
		return {
			...state,
			type: null,
			messages: []
		}

	} else if ((error || success) && !silent && type.indexOf("@@redux-form") !== 0) {
		const messages = Object.assign(state.messages);
		if (messages.length > 10) {
			messages.shift()
		}
		messages.push(error || success);
		return {
			type: error ? 'danger' : 'success',
			messages
		}
	}

	return state
};

const headerContent = (state = {content: null}, action) => {
	const {type, content} = action;

	if (type === CHANGE_HEADER_CONTENT) {
		return Object.assign({}, state, {
			content: content
		})
	} else {
		return state
	}
};

const pagination = combineReducers({
	users: paginate({
		types: [
			UsersActions.USERS_REQUEST,
			UsersActions.USERS_SUCCESS,
			UsersActions.USERS_FAILURE,
			UsersActions.USERS_COUNT_REQUEST,
			UsersActions.USERS_COUNT_SUCCESS,
			UsersActions.USERS_COUNT_FAILURE
		]
	}),
	dogs: paginate({
		types: [
			DogsActions.DOGS_REQUEST,
			DogsActions.DOGS_SUCCESS,
			DogsActions.DOGS_FAILURE,
			DogsActions.DOGS_COUNT_REQUEST,
			DogsActions.DOGS_COUNT_SUCCESS,
			DogsActions.DOGS_COUNT_FAILURE
		]
	}),
	parties: paginate({
		types: [
			PartiesActions.PARTIES_REQUEST,
			PartiesActions.PARTIES_SUCCESS,
			PartiesActions.PARTIES_FAILURE,
			PartiesActions.PARTIES_COUNT_REQUEST,
			PartiesActions.PARTIES_COUNT_SUCCESS,
			PartiesActions.PARTIES_COUNT_FAILURE
		]
	}),
	walks: paginate({
		types: [
			WalksActions.WALKS_REQUEST,
			WalksActions.WALKS_SUCCESS,
			WalksActions.WALKS_FAILURE,
			WalksActions.WALKS_COUNT_REQUEST,
			WalksActions.WALKS_COUNT_SUCCESS,
			WalksActions.WALKS_COUNT_FAILURE
		]
	}),
	exams: paginate({
		types: [
			ExamsActions.EXAMS_REQUEST,
			ExamsActions.EXAMS_SUCCESS,
			ExamsActions.EXAMS_FAILURE,
			ExamsActions.EXAMS_COUNT_REQUEST,
			ExamsActions.EXAMS_COUNT_SUCCESS,
			ExamsActions.EXAMS_COUNT_FAILURE
		]
	}),
	events: paginate({
		types: [
			EventsActions.EVENTS_REQUEST,
			EventsActions.EVENTS_SUCCESS,
			EventsActions.EVENTS_FAILURE,
			EventsActions.EVENTS_COUNT_REQUEST,
			EventsActions.EVENTS_COUNT_SUCCESS,
			EventsActions.EVENTS_COUNT_FAILURE
		]
	}),
	exits: paginate({
		types: [
			ExitsActions.EXITS_REQUEST,
			ExitsActions.EXITS_SUCCESS,
			ExitsActions.EXITS_FAILURE,
			ExitsActions.EXITS_COUNT_REQUEST,
			ExitsActions.EXITS_COUNT_SUCCESS,
			ExitsActions.EXITS_COUNT_FAILURE
		]
	}),
	intakes: paginate({
		types: [
			IntakesActions.INTAKES_REQUEST,
			IntakesActions.INTAKES_SUCCESS,
			IntakesActions.INTAKES_FAILURE,
			IntakesActions.INTAKES_COUNT_REQUEST,
			IntakesActions.INTAKES_COUNT_SUCCESS,
			IntakesActions.INTAKES_COUNT_FAILURE
		]
	}),
	treatments: paginate({
		types: [
			TreatmentsActions.TREATMENTS_REQUEST,
			TreatmentsActions.TREATMENTS_SUCCESS,
			TreatmentsActions.TREATMENTS_FAILURE,
			TreatmentsActions.TREATMENTS_COUNT_REQUEST,
			TreatmentsActions.TREATMENTS_COUNT_SUCCESS,
			TreatmentsActions.TREATMENTS_COUNT_FAILURE
		]
	}),
	files: paginate({
		types: [
			FilesActions.FILES_REQUEST,
			FilesActions.FILES_SUCCESS,
			FilesActions.FILES_FAILURE,
			FilesActions.FILES_COUNT_REQUEST,
			FilesActions.FILES_COUNT_SUCCESS,
			FilesActions.FILES_COUNT_FAILURE
		]
	})
});

const entities = combineReducers({
	users: entity({
		types: [
			UsersActions.USER_REQUEST,
			UsersActions.USER_SUCCESS,
			UsersActions.USER_FAILURE,
			UsersActions.USER_SAVE_REQUEST,
			UsersActions.USER_SAVE_SUCCESS,
			UsersActions.USER_SAVE_FAILURE,
			UsersActions.USER_DELETE_REQUEST,
			UsersActions.USER_DELETE_SUCCESS,
			UsersActions.USER_DELETE_FAILURE,
		],
		key: 'userId'
	}),
	dogs: entity({
		types: [
			DogsActions.DOG_REQUEST,
			DogsActions.DOG_SUCCESS,
			DogsActions.DOG_FAILURE,
			DogsActions.DOG_SAVE_REQUEST,
			DogsActions.DOG_SAVE_SUCCESS,
			DogsActions.DOG_SAVE_FAILURE
		],
		key: 'dogId'
	}),
	parties: entity({
		types: [
			PartiesActions.PARTY_REQUEST,
			PartiesActions.PARTY_SUCCESS,
			PartiesActions.PARTY_FAILURE,
			PartiesActions.PARTY_SAVE_REQUEST,
			PartiesActions.PARTY_SAVE_SUCCESS,
			PartiesActions.PARTY_SAVE_FAILURE,
			PartiesActions.PARTY_DELETE_REQUEST,
			PartiesActions.PARTY_DELETE_SUCCESS,
			PartiesActions.PARTY_DELETE_FAILURE,
		],
		key: 'partyId'
	}),
	walks: entity({
		types: [
			WalksActions.WALK_REQUEST,
			WalksActions.WALK_SUCCESS,
			WalksActions.WALK_FAILURE,
			WalksActions.WALK_SAVE_REQUEST,
			WalksActions.WALK_SAVE_SUCCESS,
			WalksActions.WALK_SAVE_FAILURE,
		],
		key: 'walkId'
	}),
	intakes: entity({
		types: [
			IntakesActions.INTAKE_REQUEST,
			IntakesActions.INTAKE_SUCCESS,
			IntakesActions.INTAKE_FAILURE,
			IntakesActions.INTAKE_SAVE_REQUEST,
			IntakesActions.INTAKE_SAVE_SUCCESS,
			IntakesActions.INTAKE_SAVE_FAILURE,
		],
		key: 'intakeId'
	}),
	exams: entity({
		types: [
			ExamsActions.EXAM_REQUEST,
			ExamsActions.EXAM_SUCCESS,
			ExamsActions.EXAM_FAILURE,
			ExamsActions.EXAM_SAVE_REQUEST,
			ExamsActions.EXAM_SAVE_SUCCESS,
			ExamsActions.EXAM_SAVE_FAILURE,
		],
		key: 'examId'
	}),
	events: entity({
		types: [
			EventsActions.EVENT_REQUEST,
			EventsActions.EVENT_SUCCESS,
			EventsActions.EVENT_FAILURE,
			EventsActions.EVENT_SAVE_REQUEST,
			EventsActions.EVENT_SAVE_SUCCESS,
			EventsActions.EVENT_SAVE_FAILURE,
		],
		key: 'eventId'
	}),
	exits: entity({
		types: [
			ExitsActions.EXIT_REQUEST,
			ExitsActions.EXIT_SUCCESS,
			ExitsActions.EXIT_FAILURE,
			ExitsActions.EXIT_SAVE_REQUEST,
			ExitsActions.EXIT_SAVE_SUCCESS,
			ExitsActions.EXIT_SAVE_FAILURE,
		],
		key: 'exitId'
	}),
	treatments: entity({
		types: [
			TreatmentsActions.TREATMENT_REQUEST,
			TreatmentsActions.TREATMENT_SUCCESS,
			TreatmentsActions.TREATMENT_FAILURE,
			TreatmentsActions.TREATMENT_SAVE_REQUEST,
			TreatmentsActions.TREATMENT_SAVE_SUCCESS,
			TreatmentsActions.TREATMENT_SAVE_FAILURE,
		],
		key: 'treatmentId'
	}),
	files: entity({
		types: [
			FilesActions.FILE_REQUEST,
			FilesActions.FILE_SUCCESS,
			FilesActions.FILE_FAILURE,
			FilesActions.FILE_SAVE_REQUEST,
			FilesActions.FILE_SAVE_SUCCESS,
			FilesActions.FILE_SAVE_FAILURE,
		],
		key: 'fileId'
	}),
});

const defaultModalState = {isShowing: false, title: '', message: '', button: null, onConfirm: null};

function modal(state = defaultModalState, action) {
	switch (action.type) {
		case SHOW_MODAL:
			return Object.assign({}, state, {
				isShowing: true,
				message: action.message,
				title: action.title,
				button: action.button,
				onConfirm: action.onConfirm
			});
		case HIDE_MODAL:
			return Object.assign({}, state, defaultModalState);
		default:
			return state
	}
}

const rootReducer = combineReducers({
	headerContent,
	session,
	enums,
	pagination,
	entities,
	alerts,
	routing,
	modal,
	form: formReducer
});

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js